import React from 'react';
import { DropdownWrapper } from '../QsrDept.styles';
import Input from '../../../components/Input/Input';
import { StyledButtons } from '../../RawProdGINs/RawProdGins.style';
import Button from '../../../components/Button/Button';
import { UpdateQsrMasterModalProps } from './QsrModal.types';
import Modal from '../../../components/Modal/Modal';
import { Variant } from '../../../components/Button/Button.types';
import Dropdown from '../../../components/Dropdown/Dropdown';

export const UpdateQsrDeptMasterModal = ({ open, onClose, onCancel, onConfirm, selectedQsrDeptMaster, qsrDeptMasterDescription, handleQsrDeptMasterDescription, formErrors, classOptions, handleQsrDeptMasterClassNo, qsrDeptMasterClassNo }: UpdateQsrMasterModalProps): JSX.Element => {
  return (
    <Modal
      id="updateQsrDeptMasterModal"
      open={open}
      onClose={onClose}
      title={`Update Qsr Dept Master for: ${selectedQsrDeptMaster?.label}`}
    >
      <div>
        <Input
          label="Description"
          value={qsrDeptMasterDescription}
          onChange={handleQsrDeptMasterDescription}
          errorText={formErrors?.departmentDescription}
          id="updateQsrMasterDescription"
          testId={'updateQsrMasterDescriptionInput'}
        />
        <DropdownWrapper>
          <Dropdown
            label="Class"
            id="updateQsrMasterClassNo"
            options={[{ value: undefined, label: '' }, ...classOptions]}
            value={selectedQsrDeptMaster?.classNo?.toString() ?? undefined}
            hidePlaceholder={true}
            onChange={handleQsrDeptMasterClassNo}
            errorText={formErrors?.classDescription}
            dataTestId={'UpdateDeptClassDropdown'}
          />
        </DropdownWrapper>
        <StyledButtons>
          <Button variant={Variant.Secondary} label="Cancel" onClick={onCancel}
                  testId={'UpdateMasterCloseButton'} />
          <Button label="Ok" onClick={onConfirm} testId={'UpdateMasterConfirmButton'}
                  disabled={qsrDeptMasterDescription === selectedQsrDeptMaster?.description?.trim() && qsrDeptMasterClassNo === selectedQsrDeptMaster?.classNo} />
        </StyledButtons>
      </div>
    </Modal>
  );
};

export default UpdateQsrDeptMasterModal;
